import lodash from 'lodash';
export const initialState = {
            // used to prefix urls to all api calls change when moving to dev or live !
            urlPrefix: "https://live.yourideas.org.uk/",
            //urlPrefix: "https://test.yourideas.org.uk/",
            //urlPrefix: "http://localhost:8000/",
            // the data for the current person being viewed or edited
            person: {
              firstName: "",
              lastName: "",
              pictureLocation: "",
              medicalConditions: "",
              additionalNeeds: "",
              gender: "",
              ethnicityL1: "",
              school: "",
              howDiscovered: "",
              yourIdeasId: "",
              preferedEmail: { id: "", emailAddress: "", person: "" },
              emergencyContact: {},
            },
            peopleAttendingToday: [],
            email: {},
            phone: {},
            fnf: {},
            fnfOptions: {},
            fnfEditData: {},
            test: false,
            axiosError: null,
            showHideElement: {
              // used to control visibility between componetns and call methods between components
              emailAddForm: false,
              phoneAddForm: false,
              emailEditForm: false,
              phoneEditForm: false,
              fnfAddForm: false,
              fnfEditForm: false,
              impactSaveButton:false,
              },
            dataFromSearch: {
              addedFriend: { id: null, firstName: null, lastName: null },
            },
            reportData: null,
            djangoToken: {
              access_token: "ZQ5jqFb3fecjgEM1hTuB3r1i82nnHT",
              expires_in: 36000,
              token_type: "Bearer",
              scope: "read write",
              refresh_token: "DCOgRB7Bcb3Z3UHr4K2S0Dr5lmvaVe",
            },
            peopleList: null,
            projectList: null,
            projectAliasesLive: null,
            project: null,
            projectOptions: null,
            personNotes:{},
            impact:null,
            impactPayload:{},
            loadingData:null,
        };

 //eslint-disable-next-line no-console
//console.log(lodash.random(20));

export const stateForRestore =lodash.cloneDeep(initialState);
//eslint-disable-next-line no-console
//console.log (stateForRestore)

 
